// source: src/common/integration/type/type.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.integration.type.IntegrationCategory', null, global);
goog.exportSymbol('proto.loupe.common.integration.type.IntegrationContainer', null, global);
goog.exportSymbol('proto.loupe.common.integration.type.IntegrationSubCategory', null, global);
goog.exportSymbol('proto.loupe.common.integration.type.IntegrationType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.integration.type.IntegrationContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.integration.type.IntegrationContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.integration.type.IntegrationContainer.displayName = 'proto.loupe.common.integration.type.IntegrationContainer';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.integration.type.IntegrationContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.integration.type.IntegrationContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.type.IntegrationContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    category: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subCategory: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.integration.type.IntegrationContainer}
 */
proto.loupe.common.integration.type.IntegrationContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.integration.type.IntegrationContainer;
  return proto.loupe.common.integration.type.IntegrationContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.integration.type.IntegrationContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.integration.type.IntegrationContainer}
 */
proto.loupe.common.integration.type.IntegrationContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {!proto.loupe.common.integration.type.IntegrationCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 3:
      var value = /** @type {!proto.loupe.common.integration.type.IntegrationSubCategory} */ (reader.readEnum());
      msg.setSubCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.integration.type.IntegrationContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.integration.type.IntegrationContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.integration.type.IntegrationContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSubCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.integration.type.IntegrationContainer} returns this
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional IntegrationCategory category = 2;
 * @return {!proto.loupe.common.integration.type.IntegrationCategory}
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.getCategory = function() {
  return /** @type {!proto.loupe.common.integration.type.IntegrationCategory} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.loupe.common.integration.type.IntegrationCategory} value
 * @return {!proto.loupe.common.integration.type.IntegrationContainer} returns this
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional IntegrationSubCategory sub_category = 3;
 * @return {!proto.loupe.common.integration.type.IntegrationSubCategory}
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.getSubCategory = function() {
  return /** @type {!proto.loupe.common.integration.type.IntegrationSubCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.loupe.common.integration.type.IntegrationSubCategory} value
 * @return {!proto.loupe.common.integration.type.IntegrationContainer} returns this
 */
proto.loupe.common.integration.type.IntegrationContainer.prototype.setSubCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.loupe.common.integration.type.IntegrationType = {
  SALESFORCE: 0,
  HUBSPOT: 1,
  NYLAS: 2
};

/**
 * @enum {number}
 */
proto.loupe.common.integration.type.IntegrationCategory = {
  CRM: 0,
  NOTIFICATION: 1,
  ACTIVITY_DATA: 2
};

/**
 * @enum {number}
 */
proto.loupe.common.integration.type.IntegrationSubCategory = {
  DEFAULT: 0,
  CUSTOM: 1,
  CALL: 2,
  MEETING: 3,
  EMAIL: 4,
  MESSAGE: 5
};

goog.object.extend(exports, proto.loupe.common.integration.type);
